/* Guide scope is local planning data, not a submitted quote or an order. */
(function () {
  'use strict';
  var KEY = 'amc_guide_plan_v1';
  function boot() {
    var form = document.querySelector('[data-amc-package-form]');
    if (form && !form.dataset.bound) {
      form.dataset.bound = '1';
      var status = form.querySelector('#form-error');
      function chosen() { return Array.from(form.querySelectorAll('[name="scope"]:checked')).map(function (x) { return x.value; }); }
      form.addEventListener('change', function () {
        var count = chosen().length, label = form.querySelector('#scope-count');
        if (label) label.textContent = count ? count + ' equipment area' + (count > 1 ? 's' : '') + ' selected' : 'Choose your equipment areas';
        if (count) status.hidden = true;
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var scope = chosen();
        if (!scope.length) {
          status.textContent = 'Select at least one equipment area to continue.';
          status.hidden = false;
          form.querySelector('[name="scope"]').focus();
          return;
        }
        try {
          var plan = {
            id: 'guide-' + (crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2)),
            at: Date.now(), scope: scope, stage: form.elements.stage.value,
            notes: form.elements.notes.value.trim().slice(0, 1000)
          };
          sessionStorage.setItem(KEY, JSON.stringify(plan));
          location.assign('/pages/purchase-order?type=rfq&plan=small-funeral-home');
        } catch (_) {
          status.textContent = 'Your browser could not save these selections. Please copy your notes and use the RFQ link to enter your request.';
          status.hidden = false;
        }
      });
    }
    if (location.pathname !== '/pages/purchase-order' || new URLSearchParams(location.search).get('plan') !== 'small-funeral-home') return;
    var plan;
    try { plan = JSON.parse(sessionStorage.getItem(KEY)); } catch (_) { return; }
    if (!plan || !/^guide-[a-z0-9-]+$/i.test(plan.id) || !Array.isArray(plan.scope) || !plan.scope.length || Date.now() - plan.at > 3600000) return;
    if (!window.AMCPO || typeof window.AMCPO.add !== 'function') return;
    if (!window.AMCPO.items().some(function (item) { return item.variantId === plan.id; })) {
      var ok = window.AMCPO.add({
        variantId: plan.id, custom: true, rfq: true, quoteOnly: true, qty: 1, price: 0,
        title: 'Small funeral home equipment package planning',
        url: '/pages/small-funeral-home-equipment-package',
        properties: {
          'Equipment scope': plan.scope.slice(0, 4).join('; '),
          'Project stage': String(plan.stage || 'Not specified').slice(0, 100),
          'Planning notes': String(plan.notes || 'Not provided').slice(0, 1000),
          'Pricing': 'Itemized quote requested; no equipment order placed'
        }
      });
      if (!ok) return;
    }
    sessionStorage.removeItem(KEY);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
